<div *ngIf="currentCompany.initialized" id="company-new-container" class="container">
    <company-detail [company]="currentCompany" type="create"></company-detail>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/company/create/create.component.html